import React from "react";
import { MoreVertical, Pencil, Trash2, X } from "lucide-react";

import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";

type Props = {
  title: string;
  subtitle: string;
  onCloseConversation?: () => void;
  onRenameConversation?: () => void;
  onDeleteConversation?: () => void;
  canClose?: boolean;
  canRename?: boolean;
  canDelete?: boolean;
  showMenu?: boolean;
};

export function ConversationHeader({
  title,
  subtitle,
  onCloseConversation,
  onRenameConversation,
  onDeleteConversation,
  canClose = true,
  canRename = true,
  canDelete = true,
  showMenu = true
}: Props) {
  return (
    <div className="flex w-full items-center justify-between gap-3 border-b border-line-2 bg-surface px-6 py-2 mobile:px-4">
      <div className="flex min-w-0 items-center gap-3">
        <Avatar size="md">
          <AvatarFallback className="bg-accent-soft text-accent-seed">
            A
          </AvatarFallback>
        </Avatar>
        <div className="flex min-w-0 flex-col items-start">
          <span
            className="block w-full truncate text-left text-base font-medium text-fg"
            title={title}
          >
            {title}
          </span>
          <span
            className="w-full truncate text-left text-sm text-fg-3"
            title={subtitle}
          >
            {subtitle}
          </span>
        </div>
      </div>

      {showMenu ? (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="icon-sm"
              aria-label="Conversation actions"
            >
              <MoreVertical />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            side="bottom"
            align="end"
            sideOffset={8}
            className="w-48"
          >
            <DropdownMenuItem
              disabled={!canRename}
              onSelect={() => onRenameConversation?.()}
            >
              <Pencil />
              Rename Conversation
            </DropdownMenuItem>
            <DropdownMenuItem
              variant="destructive"
              disabled={!canDelete}
              onSelect={() => onDeleteConversation?.()}
            >
              <Trash2 />
              Delete Conversation
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              disabled={!canClose}
              onSelect={() => onCloseConversation?.()}
            >
              <X />
              Close Conversation
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      ) : null}
    </div>
  );
}
